import React from 'react'
import AddressBookSvg from 'images/modules/Manage/i-menu-addressbook.svg?raw'

export { default as AddressBookUrl } from 'images/modules/Manage/i-menu-addressbook.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: AddressBookSvg}} />
)
